import React, { useState } from "react"
import { Navigate } from "react-router-dom"

// Profile
import Reports from "pages/Reports/Reports/index"
// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"  

// setting 
import IcodeIndex from "pages/Setting/Icode"
import IndustryIndex from "pages/Setting/Industry"
import HostingIndex from "pages/Setting/Hosting"  
import AccessDenied from "./AccessDenied"  
import configure from "configure" 
import ResourcePlanIndex from "pages/Work/ResourcePlan/ResourcePlanIndex" 
import CalenderIndex2 from "pages/Calender/CalenderIndex2" 
import Crendential from "pages/Credentials/Crendential"
import EditCredential from "pages/Setting/GeneralSettings/EditCredentials/EditIndex"
import Profile from "pages/Profile/Profile"

import ViewDocument from "pages/Profile/ViewDocument"

import RolesPermission from "pages/AuditLog/RolesPermission"
import KnowledgeBase from "pages/KnowledgeBase/KnowledgeBase"
import AddCredential from "pages/Setting/GeneralSettings/AddCredentials/AddIndex"
import EditTopic from "pages/KnowledgeBase/EditTopic/EditTopic"
import AddTopic from "pages/KnowledgeBase/AddTopic/AddTopic"
import ViewTopic from "pages/KnowledgeBase/ViewTopic/ViewTopic"
import EditDocument from "pages/Profile/EditDocument"
import KnowledgeIndex from "pages/Setting/Knowledge Base"
import ProjectIndex from "pages/WorkModule/Projects/ProjectIndex"

import AddProject from "pages/WorkModule/Projects/AddProject"
import EditProject from "pages/WorkModule/Projects/EditProject/EditProject"
import ViewProject from "pages/WorkModule/Projects/ViewProject/ViewProject"
import EditDedicatedProject from "pages/WorkModule/Projects/EditProject/EditDedicatedProject"
import EditMaintenanceProject from "pages/WorkModule/Projects/EditProject/EditMainenanceProject"
 

// Work -> General Settings
import GeneralTask from "pages/WorkModule/GeneralTask/GeneralTask" 
import ViewApproveDoc from "pages/Dashboard/ViewApproveDoc"
import DragDashboard from "pages/Dashboard/DragDashboard"
import NotificationPage from "pages/Setting/NotificationPage"
import MainDmResourcePlan from "pages/WorkModule/Resource/MainDmResourcePlan"
import TeamsWeeklyPlan from "pages/WorkModule/Resource/TeamsWeeklyPlan"
import ProjectWeeklyPlan from "pages/WorkModule/Resource/ProjectWeeklyPlan"
import DigitalPlanIndex from "pages/WorkModule/Project Plan/DigitalPlanIndex"
import MainDmProjectPlan from "pages/WorkModule/Project Plan/MainDmProjectPlan"
import DigitalMarketingIndex from "pages/WorkModule/Digital Marketing/DigitalMarketingIndex"
import DmAddProject from "pages/WorkModule/Digital Marketing/DmAddProject"
import EditProjectIndex from "pages/WorkModule/Digital Marketing/EditProject/EditProjectIndex"
import DmSharedNotes from "pages/WorkModule/Digital Marketing/ViewProject/DmSharedNotes"
import DigitalMarketingSeting from "pages/Setting/Digital Marketing/DigitalMarketingSeting"
import CompleteSprint from "pages/WorkModule/Project Plan/CompleteSprint"  
import DmMonthlyApproval from "pages/WorkModule/Project Plan/Monthly Approval/DmMonthlyApproval"
import MonthlyPlanning from "pages/WorkModule/Project Plan/Monthly planning/MonthlyPlanning"
import ProjectResourcePlanIndex from "pages/WorkModule/Projects/ProjectPlan/ProjectPlanIndex"
import ProjectSprintIndex from "pages/WorkModule/Projects/ProjectPlan/ProjectSprintIndex"
import ResourceIndex from "pages/WorkModule/Resource/ResourceIndex"
import PmResourcePlanIndex from "pages/WorkModule/Resource/PmResourcePlanIndex"
import GanttChart from "pages/Gantt Chart/GanttChart"
import ProjectTickets from "pages/WorkModule/Support/Tickets/ProjectTickets"
import SupportIndex from "pages/WorkModule/Support/Tickets/SupportIndex"
import TestCaseIndex from "pages/WorkModule/Support/Test Cases/TestCaseIndex"
import CaseIndex from "pages/WorkModule/Support/Test Cases/Cases/CaseIndex"
import ProjectTestIndex from "pages/WorkModule/Support/Test Cases/Project Test/ProjectTestIndex"  
import MaintenanceResourceIndex from "pages/WorkModule/Resource/MaintenanceResourceIndex"
import ExistingMaintenanceScreen from "pages/WorkModule/Projects/Maintenance/ExistingMainenance"
import DevResourceIndex from "pages/WorkModule/Resource/Develop Resource/DevResourceIndex" 
 
import TicketPlanning from "pages/WorkModule/Support/Help/TicketsPlannings"
import ShowTicketPlanning from "pages/WorkModule/Support/Help/ShowTicketPlanning" 
import Hirechynew from "pages/Separate/Hirechy/HirechyNew"   
import CalenderIndex3 from "pages/Calender/CalenderIndex3"  
import HostingIndexMain from "pages/WorkModule/Hosting/HostingIndexMain"
import TimeSheetReport from "pages/Reports/TimeSheetReport"  

const authProtectedRoutes = [
  {
    path: `${configure.appUrl}dashboard`,
    component: <DragDashboard />,
    // component: <Dashboard />,
  },
  {
    path: `${configure.appUrl}dashboard/drag_drop`,
    component: <Dashboard />,
    // component: <DragDashboard />,
  },
  {
    path: `${configure.appUrl}profile`,
    component: <Profile />,
  },
   
  {
    path: `${configure.appUrl}calendar`,
    component: <CalenderIndex2 />,
    module_id: "85",
    type: "view",
  },
  {
    path: `${configure.appUrl}calender/:id`,
    component: <CalenderIndex2 />,
    module_id: "85",
    type: "view",
  }, 
  {
    path: `${configure.appUrl}viewapprovedoc/:id`,
    component: <ViewApproveDoc />,
    module_id: "66",
    type: "edit",
  }, 
 
  {
    path: `${configure.appUrl}setting/generalsetting/:id`,
    component: <EditCredential />,
  },
  {
    path: `${configure.appUrl}setting/generalsetting/addtab`,
    component: <AddCredential />,
  },
  
  
  // setting module
  { path: `${configure.appUrl}setting/icode`, component: <IcodeIndex /> },
  {
    path: `${configure.appUrl}setting/knowledge-base`,
    component: <KnowledgeIndex />,
    module_id: "81",
    type: "view",
  },
  {
    path: `${configure.appUrl}setting/industry`,
    component: <IndustryIndex />,
    module_id: "83",
    type: "view",
  },
  { path: `${configure.appUrl}setting/hosting`, component: <HostingIndex /> },
  
   

  // work module
  {
    path: `${configure.appUrl}work/resource-plan`,
    component: <ResourcePlanIndex />,
  },
  {
    path: `${configure.appUrl}work/hosting`,
    component: <HostingIndexMain />,
    module_id: "29",
    type: "view",
  },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: `${configure.appUrl}`,
    exact: true,
    component: <Navigate to={`${configure.appUrl}dashboard`} />,
  }, 

  {
    path: `${configure.appUrl}credentials`,
    component: <Crendential />,
    module_id: "10",
    type: "view",
  },
  {
    path: `${configure.appUrl}viewdocument/:id`,
    component: <ViewDocument />,
  },
  {
    path: `${configure.appUrl}editdocument/:id`,
    component: <EditDocument />,
  },
  {
    path: `${configure.appUrl}audit/roles`,
    component: <RolesPermission />,
  }, 

  {
    path: `${configure.appUrl}audit-log/rolespermission`,
    component: <RolesPermission />,
  },

  // Knowledge Base Module
  {
    path: `${configure.appUrl}knowledgebase`,
    component: <KnowledgeBase />,
    module_id: "95",
    type: "view",
  },
  {
    path: `${configure.appUrl}edittopic`,
    component: <EditTopic />,
  },
  {
    path: `${configure.appUrl}addtopic`,
    component: <AddTopic />,
  },
  {
    path: `${configure.appUrl}viewtopic`,
    component: <ViewTopic />,
  }, 

  // Work Module 
  {
    path: `${configure.appUrl}work/activities`,
    component: <GeneralTask />,
    module_id: "26",
    type: "view",
  },
 

  {
    path: `${configure.appUrl}flaws-gap`, component: <Reports />,
    module_id: "96",
    type: "view",
  },
  {
    path: `${configure.appUrl}notifications`,
    component: <NotificationPage />
  },

  // Digital Marketing Project

  {
    path: `${configure.appUrl}weekly-plan/digital-marketing`,
    component: <MainDmResourcePlan />,
    type: "view",
  },
  {
    path: `${configure.appUrl}teams-weekly-plan/digital-marketing`,
    component: <TeamsWeeklyPlan />,
    module_id: "98",
    type: "view",
  },
  {
    path: `${configure.appUrl}project-weekly-plan/digital-marketing`,
    component: <ProjectWeeklyPlan />,
    module_id: "99",
    type: "view",
  },
  {
    path: `${configure.appUrl}initial-project-plan/digital-marketing`,
    component: <DigitalPlanIndex />,
    module_id: "100",
    type: "view",
  },
  {
    path: `${configure.appUrl}initial-project-plan/:id/:seo`,
    component: <MainDmProjectPlan />,
    module_id: "100",
    type: "view",
  },
  {
    path: `${configure.appUrl}work/digital_marketing`,
    component: <DigitalMarketingIndex />,
    module_id: "101",
    type: "view",
  },
  {
    path: `${configure.appUrl}digital_marketing/add_project`,
    component: <DmAddProject />,
    module_id: "101",
    type: "add",
  },
  {
    path: `${configure.appUrl}digital_marketing/edit_project/:id`,
    component: <EditProjectIndex />,
    module_id: "101",
    type: "edit",
  },
  {
    path: `${configure.appUrl}work/digital_marketing/notes/:noteId`,
    component: <DmSharedNotes />,
    module_id: "101",
    type: "edit",
  },
  {
    path: `${configure.appUrl}setting/digital_marketing`,
    component: <DigitalMarketingSeting />,
    module_id: "102",
    type: "add",
  },
  {
    path: `${configure.appUrl}complete_sprint`,
    component: <CompleteSprint />,
    type: "view",
  },
  {
    path: `${configure.appUrl}monthly-planning`,
    component: <MonthlyPlanning />,
    type: "view",
  },
  {
    path: `${configure.appUrl}monthly-approval`,
    component: <DmMonthlyApproval />,
    module_id: "105",
    type: "view",
  }, 

  // Project Section 
  {
    path: `${configure.appUrl}work/projects`,
    component: <ProjectIndex />,
    module_id: "25",
    type: "view",
  },
  {
    path: `${configure.appUrl}work/projects-plan/:id`,
    component: <ProjectResourcePlanIndex />,
    module_id: "25",
    type: "view",
  },
  {
    path: `${configure.appUrl}work/add-project`,
    component: <AddProject />,
    module_id: "25",
    type: "add",
  },
  {
    path: `${configure.appUrl}work/edit-project/:id`,
    component: <EditProject />,
    module_id: "25",
    type: "edit",
  },
  {
    path: `${configure.appUrl}complete_sprint/development`,
    component: <ProjectSprintIndex />,
    module_id: "25",
    type: "view",
  },
  {
    path: `${configure.appUrl}initial-project-plan/development`,
    component: <DevResourceIndex />,
    module_id: "88",
    type: "view",
  },
  {
    path: `${configure.appUrl}initial-project-plan/:id`,
    component: <ResourceIndex />,
    module_id: "88",
    type: "view",
  },
  {
    path: `${configure.appUrl}weekly-plan/development`,
    component: <PmResourcePlanIndex />,
    module_id: "88",
    type: "view",
  },

  {
    path: `${configure.appUrl}maintenece-project-plan/:id`,
    component: <MaintenanceResourceIndex />,
    module_id: "88",
    type: "view",
  },
  {
    path: `${configure.appUrl}work/edit-maintenance-project`,
    component: <ExistingMaintenanceScreen />,
    module_id: "25",
    type: "edit",
  },

  // Gantt Chart
  {
    path: `${configure.appUrl}gantt-chart`,
    component: <GanttChart />,
    module_id: "106",
    type: "view",
  },

  // // Support Section
  {
    path: `${configure.appUrl}support/ticket`,
    component: <ProjectTickets />,
    module_id: "27",
    type: "view",
  },
  {
    path: `${configure.appUrl}support/tickets/:id`,
    component: <SupportIndex />,
    module_id: "27",
    type: "view",
  },
  {
    path: `${configure.appUrl}support/test-cases`,
    component: <TestCaseIndex />,
    module_id: "107",
    type: "view",
  },
  {
    path: `${configure.appUrl}support/test-cases/:id`,
    component: <CaseIndex />,
    module_id: "107",
    type: "view",
  },
  {
    path: `${configure.appUrl}support/project-test/:id`,
    component: <ProjectTestIndex />,
    module_id: "107",
    type: "view",
  },
 
  {
    path: `${configure.appUrl}timesheet-report`,
    component: <TimeSheetReport />,
    module_id: 32,
    type: "view",
  },
  

  {
    path: `${configure.appUrl}ticket-planning`,
    component: <TicketPlanning />,
  },
  {
    path: `${configure.appUrl}earth-ticket-planning`,
    component: <ShowTicketPlanning />,
  },
 
 
  // Hirecy

  {
    path: `${configure.appUrl}company-structure`,
    component: <Hirechynew />,
    module_id: "116",
    type: "view",
  }, 
]


const publicRoutes = [
  { path: `${configure.appUrl}logout`, component: <Logout /> },
  { path: `${configure.appUrl}login`, component: <Login /> },
  { path: `${configure.appUrl}forgot-password`, component: <ForgetPwd /> },
  { path: `${configure.appUrl}register`, component: <Register /> },
  { path: `${configure.appUrl}access-denied`, component: <AccessDenied /> },
 
  
  {
    path: `${configure.appUrl}calendar/:id`,
    component: <CalenderIndex3 />,
  },
  // {
  //   path: `${configure.appUrl}staff/Letters/:id`,
  //   component: <GenerateLinkLetters />
  // },
]

export { authProtectedRoutes, publicRoutes }
